/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {useMemo} from 'react';
import PropTypes from 'prop-types';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

import {jsxParser} from '@amblique/base/app/helpers/jsx-parser';

/**
 * @param {{source: string, className: string}} args
 *
 * @returns {React.DOMElement}
 */
export function Markup({source, as = Box, className = '', ...props}) {
  const children = useMemo(() => {
    return source ? jsxParser.parse(source) : null;
  }, [source]);

  return children && <Box as={as} className={`${className} amb-markup`} {...props}>{children}</Box>;
}

Markup.displayName = 'Markup';
Markup.propTypes = {
  as: PropTypes.node,
  className: PropTypes.string,
  source: PropTypes.string,
};
